import React from 'react'
import { useTranslations } from 'next-intl'

import { type ProductSlug, ProductSlugSchema } from '~/schemas/browserUrl'
import SearchHotelForm from '../search-and-results/SearchHotelForm'
import SearchCarHireForm from '../search-and-results/SearchCarHireForm'
import SearchExperienceForm from '../search-and-results/SearchExperienceForm'

type Props = {
  productSlug: ProductSlug
}

const SearchPageFormWrapper = ({ productSlug }: Props) => {
  const t = useTranslations('pages.search')

  switch (productSlug) {
    case ProductSlugSchema.enum.hotels:
      return <SearchHotelForm buttonText={t('hotels.actions.search_button')} />
    case ProductSlugSchema.enum.cars:
      return (
        <SearchCarHireForm
          buttonText={t('car_hire.actions.search_button')}
          enablePopularDestinationFlow
        />
      )
    case ProductSlugSchema.enum.experiences:
      return <SearchExperienceForm buttonText={t('experiences.actions.search_button')} />
    default:
      return null
  }
}

export default SearchPageFormWrapper
